export default __webpack_public_path__ + "static/media/konstantin_s.2e180bc6.jpg";